<script lang="ts">
	let { data }: { data: unknown } = $props();

	const applySyntaxHighlighting = (jsonString: string) => {
		jsonString = jsonString.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
		return jsonString.replace(
			/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)/g,
			function (match: string) {
				// number
				let color = 'ff9e64';
				if (/^"/.test(match)) {
					if (/:$/.test(match)) {
						// key
						color = '9aa5ce';
					} else {
						// string
						color = '9ece6a';
					}
				} else if (/true|false/.test(match)) {
					// boolean
					color = 'ff9e64';
				} else if (/null/.test(match)) {
					// null
					color = 'f7768e';
				}
				return '<span style="color:#' + color + '">' + match + '</span>';
			}
		);
	};
</script>

<pre>
	<code>
		<!-- eslint-disable-next-line svelte/no-at-html-tags -->
		{@html applySyntaxHighlighting(JSON.stringify(data, null, 4))}
	</code>
</pre>

<style>
	pre {
		padding: 16px;
		border: 1px solid #ddd;
		background-color: #24283b;
		color: #cfc9c2;
		font-size: 1.14rem;
		white-space: pre;
		overflow-x: auto;
	}
</style>
